export default "__VITE_ASSET__SMDuFi9D__"